import {useNavigationState} from '@react-navigation/native';

interface NavigationStateResult {
  routes: any[];
  coachID: string;
  coachIDparams?: string;
}

export const useMyTeamsNavigationState = (): NavigationStateResult => {
  const state = useNavigationState(state => state);

  const previousRoute = state.routes[state.index - 1];
  const currentRoute = state.routes[state.index];

  const coachID = previousRoute?.params?.coachId;

  const coachIDparams =
    currentRoute && currentRoute.params
      ? currentRoute.params.coachId
      : undefined;

  // If there is only one route in stack
  if (state.routes.length === 1) {
    if (currentRoute?.params) {
      currentRoute.params.isViewTeam = false;
    }
  }

  return {
    routes: state.routes,
    coachID,
    coachIDparams,
  };
};
